import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { ellipsis, resetButton } from '@/styles/common';
import { Typography } from '@/components/Typography/Typography';

export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid ${COLORS.grey[400]};
`;

export const ClipboardButton = styled.button`
  width: max-content;
  height: max-content;
  ${resetButton};
  cursor: pointer;
`;

export const SuccessModalValue = styled(Typography)`
  ${ellipsis};
  width: 100%;
  max-width: 300px;
  color: ${COLORS.grey[950]};
`;
